module.exports = __webpack_public_path__ + "img/markery.8f90c1b2.svg";